/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import { ContactImportance } from '@bb/users';
import { AgentsContext } from 'contexts';
import { Select, UserSelect, Text, Title } from 'components';
import FormContext from '../FormContext';
import ContactModalContext from './ContactModalContext';

const Details: React.FC = () => {
  const { orgUsersMap } = useContext(AgentsContext);
  const { contacts, userId } = useContext(FormContext);
  const { contact, modeType, setContact } = useContext(ContactModalContext);

  const contactIds = useMemo(
    () => contacts?.map(({ contactId }) => contactId),
    [contacts],
  );

  return (
    <StyledContainer>
      <div>
        <Select
          label="Contact Status"
          required
          value={contact?.importance}
          onChange={importance => setContact({ ...contact!, importance })}
          options={Object.values(ContactImportance).map(value => ({
            label: value,
            value,
          }))}
          getPopupContainer={node => node.parentElement}
        />
        {modeType === 'edit' ? (
          <div>
            <Text strong dataCy={'select-agent-title'}>
              Select Agent
            </Text>
            <Title level={2} data-cy={'agent-name-title'}>
              {contact!.firstName} {contact!.lastName}
            </Title>
          </div>
        ) : (
          <UserSelect
            showSearch
            backEndFilter="showingConfig"
            targetUserIds={[userId!]}
            optionLabelProp="label"
            label="Select Agent"
            value={[contact!.contactId]}
            onChange={([contactId]) =>
              setContact({ ...contact!, contactId, ...orgUsersMap![contactId] })
            }
            getPopupContainer={node => node.parentElement}
            filter={user =>
              user.id !== userId && !contactIds?.includes(user.id)
            }
          />
        )}
      </div>
    </StyledContainer>
  );
};

export default Details;

const StyledContainer = styled.div`
  grid-row: 1 / span 2;
  & > div {
    display: grid;
    gap: 16px;
  }
`;
